(function(module) {
    'use strict';

    function DisplaysCtrl(utils, WS, Display, Group, Account, App, Vendor, ListModifier, Includes, $scope, $state, _, $mdDialog, Store, envService, $timeout, Playlist, AppStylesInPlaylist, Schedule, $window, displayBulkClear) {
        this.getGroups = () => {
            return Group
                .find({ filter: Includes.groups })
                .$promise;
        };

        this.getDisplays = () => {
            return Display
                .find({ filter: Includes.displays })
                .$promise;
        };

        this.getAccountTotalDisplays = () => {
            const account = Store.getCurrentAccount();
            return Account
                .findById({ id: account.id, filter: Includes.accountTotalDisplays })
                .$promise;
        };

        this.getApps = () => {
            return App
                .find({ filter: Includes.apps })
                .$promise;
        };

        this.getPlaylists = () => {
            return Playlist
                .find()
                .$promise;
        };

        this.getVendors = () => {
            return Vendor
                .find()
                .$promise;
        };

        this.getSchedules = () => {
            return Schedule
                .find()
                .$promise;
        };

        this.addAppPlaylistStylesWhenFromPlaylist = (playlists, displays) => {
            displays.forEach((display) => {
                if (display.playlistId && display.playlists) {
                    playlists.forEach((playlist) => {
                        if (display.playlistId === playlist.id) {
                            display.playlists.apps = playlist.appsWithStyles;
                        }
                    });
                }
            });
        };

        this.addAppPlaylistStylesWhenFromGroup = (playlists, displays) => {
            displays.forEach((display) => {
                if (display.groupId && display.groups && display.groups.playlistId) {
                    playlists.forEach((playlist) => {
                        if (display.groups.playlistId === playlist.id) {
                            display.groups.playlists.apps = playlist.appsWithStyles;
                        }
                    });
                }
            });
        };

        this.createAppStylesInPlaylist = (playlists, apps) => {
            playlists.forEach((playlist) => {
                this.appsWithStylesInPlaylist = AppStylesInPlaylist.getAppStylesInPlaylist(playlist.apps, apps);
                playlist.appsWithStyles = [];
                playlist.appsWithStyles = this.appsWithStylesInPlaylist;
            });
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.setDefault = () => {
            this.loading = true;
            this.records = [];
            this.appsWithStyles = [];

            this.subscriptions = {};
            this.selectAllCheckbox = false;
            this.selectedCount = 0;

            this.totalDisplays = 0;
            this.displays = null;
            this.apps = null;
            this.groups = null;
            this.playlists = null;
            this.vendors = null;
            this.schedules = null;

            // bulk actions
            this.actions = [
                {
                    id: 'reloadApp',
                    name: 'Reload App',
                },
                {
                    id: 'reboot',
                    name: 'Reboot Device',
                },
                {
                    id: 'updateApp',
                    name: 'Update Rocket Player',
                },
                {
                    id: 'screenOn',
                    name: 'Turn Screen On (Samsung only)',
                },
                {
                    id: 'screenOff',
                    name: 'Turn Screen Off (Samsung only)',
                },
            ];
        };

        this.getData = () => {
            this.getDisplays()
                .then((response) => {
                    this.loading = false;
                    this.displays = Store.setMultiModelData('displays', response);
                    _.each(this.displays, (display) => this.addSubscription(display));
                })
                .then(() => {
                    return Promise.all([this.getAccountTotalDisplays()]).then(([response]) => {
                        const subscriptions = _.get(response, 'subscriptions');
                        const displays = _.get(response, 'displays', []).length;

                        const numberOfSubscriptionsLeft = Number(subscriptions) - Number(displays)
                        if(numberOfSubscriptionsLeft < 0){
                            this.totalDisplays = 0;
                        } else {
                            this.totalDisplays =numberOfSubscriptionsLeft
                        }
                    }).catch((error) => {
                        console.log('error', error);
                    });
                })
                .then(() => {
                    Promise
                        .all([this.getVendors(), this.getGroups(), this.getApps(), this.getPlaylists(), this.getSchedules()])
                        .then(([vendors, groups, apps, playlists, schedules]) => {
                            this.groups = Store.setMultiModelData('groups', groups);
                            this.apps = Store.setMultiModelData('apps', apps);
                            this.playlists = Store.setMultiModelData('playlists', playlists);
                            this.schedules = Store.setMultiModelData('schedules', schedules);

                            Store.setMultiModelData('vendors', vendors);
                            this.vendors = _.keyBy(vendors, 'type');

                            //create styles object for apps in playlist
                            this.createAppStylesInPlaylist(this.playlists, this.apps);

                            //add styles to proper playlist inside tv
                            this.addAppPlaylistStylesWhenFromPlaylist(this.playlists, this.displays);

                            //add styles to proper group inside tv - if playlist comes from group
                            this.addAppPlaylistStylesWhenFromGroup(this.playlists, this.displays);

                            if (!$scope.$$phase) {
                                $timeout(() => {
                                    $scope.$apply();
                                });
                            }
                        });

                });
        };

        this.$onInit = () => {
            this.utils = utils;

            this.orderBy = 'name';
            this.user = Store.getCurrentUser();
            this.account = Store.getCurrentAccount();

            this.cardModel = {
                title: 'Connect my first display',
                subtitle: 'Use PIN displayed on the device.',
            };
            this.featuresFlag = envService.read('features');

            this.setDefault();
            this.getData();
        };

        this.$onDestroy = () => {
            _.each(this.records, (record) => {
                record.unsubscribe('status');
                record.discard();
            });
        };

        this.addSubscription = ({ id }) => {
            const recordName = `display:${id}`;
            WS.record.setDataWithMetadata(recordName, 'screenshot.small.enabled', true);
            WS.record.getRecord(recordName).whenReady((record) => {
                record.subscribe((UPDATED_RECORD) => {
                    const { cpu, ram, disk, online, screenshot, temperature, lastSeen, on, rocket } = UPDATED_RECORD;
                    if (cpu) {
                        ListModifier.updateAttribute(this.displays, id, 'cpu', cpu);
                    }

                    if (ram) {
                        ListModifier.updateAttribute(this.displays, id, 'ram', ram);
                    }

                    if (disk) {
                        ListModifier.updateAttribute(this.displays, id, 'disk', disk);
                    }

                    if (_.isBoolean(online)) {
                        ListModifier.updateAttribute(this.displays, id, 'online', online);
                    }

                    if (_.isBoolean(on)) {
                        ListModifier.updateAttribute(this.displays, id, 'on', on);
                    }

                    if (screenshot) {
                        ListModifier.updateAttribute(this.displays, id, 'screenshot', screenshot);
                    }

                    if (temperature) {
                        ListModifier.updateAttribute(this.displays, id, 'temperature', temperature);
                    }

                    if (lastSeen) {
                        ListModifier.updateAttribute(this.displays, id, 'lastSeen', lastSeen);
                    }

                    if (rocket) {
                        ListModifier.updateAttribute(this.displays, id, 'rocket', rocket);
                    }

                    if (cpu || ram || disk || _.isBoolean(online) || _.isBoolean(on) || screenshot || temperature || lastSeen || rocket) {
                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    }
                }, true);
                this.records.push(record);
            });

        };

        this.bulkAction = (action) => {
            const selectedDisplayIds = this.getSelectedDisplaysId();

            $mdDialog.show({
                locals: {
                    title: `Are you sure you want to run action of: "${action.name}" on ${selectedDisplayIds.length} selected device/s?`,
                    confirmText: 'Yes',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        selectedDisplayIds.forEach((id) => {
                            const eventName = `display:${id}:${action.id}`;
                            if (['screenOff', 'screenOn'].includes(action.id)) {
                                const display = _.find(this.displays, { id });
                                const recordName = `display:${id}`;
                                if (display && (display.type === 'samsung' || display.type === 'tizen')) {
                                    WS.record.setDataWithMetadata(recordName, 'on', action.id === 'screenOn');
                                }
                            } else {
                                WS.event.emit(eventName);
                            }
                        });
                        this.unselectAll();
                        $mdDialog.hide();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });

        };

        this.getSelectedDisplaysId = () => {
            return _.chain(this.displays)
                .filter({ selected: true })
                .map((item) => item.id)
                .value();
        };

        this.unselectAll = () => {
            this.selectAllCheckbox = false;
            this.displays.forEach((display) => {
                display.selected = false;
            });
            this.updateSelectedCount();
        };

        this.selectAll = () => {
            this.filteredItems.forEach((display) => {
                display.selected = this.selectAllCheckbox;
            });
            this.updateSelectedCount();
        };

        this.updateSelectedCount = () => {
            this.selectedCount = _.chain(this.displays).filter((display) => display.selected).size().value();
        };

        this.select = () => {
            this.updateSelectedCount();
        };

        this.delete = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to permanently remove selected device/s?',
                    confirmText: 'Yes, Remove',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.removeSelected().then($scope.cancel);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.removeSelected = () => {
            const ids = _.chain(this.displays)
                .filter({ selected: true })
                .map((item) => item.id)
                .value();

            return Display.destroyAll({
                where: { id: { inq: ids } },
            })
                .$promise
                .then(() => {
                    _.remove(this.displays, (display) => _.indexOf(ids, display.id) >= 0);
                    this.selectAllCheckbox = false;
                    if (this.displays.length === 0) {
                        this.selectedCount = 0;
                    }
                })
                .catch((error) => {
                    console.error('error', error);
                });

        };

        this.openMenu = ($mdOpenMenu, event) => {
            if (this.selectedCount.length) {
                return false;
            } else {
                $mdOpenMenu(event);
            }
        };

        this.goToGroups = () => {
            $state.go('root.groups');
        };

        // this.goToViewDisplay = (id) => {
        //     $state.go('root.displays.view', { id: id });
        // };

        this.updateAllDisplays = (data) => {
            const selectedDisplayIds = this.getSelectedDisplaysId();
            const query = {
                where: { id: { inq: selectedDisplayIds } },
            };
            Display
                .updateAll(query, data)
                .$promise

                // include relationships are only available on find so we need to re-fetch the data
                // https://docs.strongloop.com/display/public/LB/Include+filter
                .then(() => {
                    return this.getDisplaysWithIds(selectedDisplayIds);
                })
                .then((response) => {
                    // for each item in the response update the view
                    _.forEach(response, (item) => {
                        // get WS data and merge with DB response
                        WS.record.snapshot(`display:${item.id}`, (error, data) => {
                            const { cpu, ram, disk, online, screenshot, temperature, lastSeen, rocket } = data;
                            ListModifier.update(this.displays, _.extend({}, item, {
                                cpu,
                                ram,
                                disk,
                                online,
                                screenshot,
                                temperature,
                                lastSeen,
                                rocket,
                            }));
                        });
                    });

                    //create styles object for apps in playlist
                    this.createAppStylesInPlaylist(this.playlists, this.apps);

                    //add styles to proper playlist inside tv
                    this.addAppPlaylistStylesWhenFromPlaylist(this.playlists, this.displays);

                    //add styles to proper group inside tv - if playlist comes from group
                    this.addAppPlaylistStylesWhenFromGroup(this.playlists, this.displays);

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                })
                .then(() => {
                    this.selectAllCheckbox = false;
                    this.updateSelectedCount();
                })
                .catch((error) => {
                    console.error('error', error);
                });
        };

        this.goToAddGroups = () => {
            $state.go('root.groups.add');
        };

        this.goToAppStore = () => {
            $state.go('root.app-store');
        };

        this.beforeClearingModal = (type) => {
            $mdDialog.show({
                locals: {
                    title: `Are you sure you want to clear ${type} assignment for all selected displays?`,
                    confirmText: 'Yes, clear',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.updateAllDisplays(displayBulkClear.buildClearPayload(type));
                        $scope.cancel();

                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };
        this.bulkAssignmentModal = (type, dataToUpdate) => {
            const modalTypeOverride = 'information';
            $mdDialog.show({
                locals: {
                    title: `You are assigning a new ${type} to the selected displays. Would you like to continue?`,
                    confirmText: 'Yes',
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        this.updateAllDisplays(dataToUpdate);
                        $scope.cancel();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.assignApp = (appId) => {
            if (!appId) {
                this.beforeClearingModal('app');

            } else {
                const dataToUpdate = { groupId: null, playlistId: null, scheduleId: null, appId };
                this.bulkAssignmentModal('app', dataToUpdate);
            }

        };

        this.addToGroup = (groupId) => {
            if (!groupId) {
                this.beforeClearingModal('group');
            } else {
                const dataToUpdate = { appId: null, playlistId: null, scheduleId: null, groupId };
                this.bulkAssignmentModal('group', dataToUpdate);
            }

        };

        this.addToPlaylist = (playlistId) => {
            if (!playlistId) {
                this.beforeClearingModal('playlist');
            } else {
                const dataToUpdate = { appId: null, groupId: null, scheduleId: null, playlistId };
                this.bulkAssignmentModal('playlist', dataToUpdate);
            }
        };

        this.addToSchedule = (scheduleId) => {
            if (!scheduleId) {
                this.beforeClearingModal('schedule');
            } else {
                const dataToUpdate = { appId: null, groupId: null, playlistId: null, scheduleId };
                this.bulkAssignmentModal('schedule', dataToUpdate);
            }
        };

        this.getDisplaysWithIds = (ids) => {
            return Display.find({
                where: { id: { inq: ids } },
                filter: Includes.displays,
            }).$promise;
        };

        this.goToAddPlaylists = () => {
            $state.go('root.playlists.add');
        };

        this.isUpToDate = (display) => {
            const type = _.get(display, 'type');
            const vendor = type === 'chrome' ? 'browser' : type;
            if (!vendor) return true;

            const latestVersion = _.get(this, `vendors[${vendor}].version`);
            if (!latestVersion) return true;

            const currentVersion = _.get(display, 'rocket');
            const LATEST = Number(latestVersion.split('1.1.')[1]);
            const CURRENT = Number(currentVersion.split('1.1.')[1]);
            return CURRENT >= LATEST;
        };
    }

    module
        .config(function($stateProvider, $translatePartialLoaderProvider, ScrollBarsProvider) {

            // Route
            $stateProvider
                .state('root.displays', {
                    url: '/displays',
                    data: {
                        pageTitle: 'PLAYERS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<displays-component />',
                        },
                    },
                    bodyClass: 'page--displays',
                });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/displays');

        })

        .component('displaysComponent', {
            templateUrl: '/js/displays/displays.html',
            controller: DisplaysCtrl,
        });

})
(angular.module('rocket.components'));
